document.addEventListener('DOMContentLoaded', () => {

  /* =========================
  SECTION REVEAL
  ========================= */

  const sections = document.querySelectorAll('.shopify-section');

  const observer = new IntersectionObserver((entries)=>{

    entries.forEach((entry)=>{

      if(entry.isIntersecting){

        entry.target.classList.add('akya-visible');

      }

    });

  },{
    threshold:0.08
  });

  sections.forEach((section)=>{

    section.classList.add('akya-reveal');

    observer.observe(section);

  });

});